import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "container text-center",
  style: {"margin-top":"20px"}
}
const _hoisted_3 = {
  key: 1,
  class: "text-big custom-theme"
}
const _hoisted_4 = { class: "container maxWidth-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px"} }, null, -1)
const _hoisted_6 = { class: "title-container" }
const _hoisted_7 = { class: "title-text" }
const _hoisted_8 = { class: "report-title" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", { class: "hr-magazine hr-magazine-thick hr-magazine-left hr-magazine-short" }, null, -1)

import { provide, ref } from "vue";
import cmsContentMap from "../../services/cms/cms-content-map";
import { useAxios, useCmsGetByUid } from "../../composables/api";
import { CompositeHeadApiModel } from "../../api-models";
import { settleAll } from "../../services/utilities/settle-all";
import CmsTextPage from "../cms/cms-text-page.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ad-hoc-group-report',
  props: {
    name: {},
    userIds: {}
  },
  setup(__props: any) {

const props = __props;

const isLoaded = ref(false);
const error = ref<string | null>(null);

const { data: reportDoc, promise: reportPromise } = useCmsGetByUid(
  "cms-report",
  cmsContentMap.adhocReports.groupReportUid,
);

const { data: groupData, promise: dataPromise } = useAxios<CompositeHeadApiModel>(
  `/api/head/adhoc/${props.name}/${props.userIds}`,
);

provide("groupHeadData", groupData);

settleAll<any>([reportPromise, dataPromise])
  .then(() => {
    isLoaded.value = true;
  })
  .catch(() => {
    error.value =
      "There was a problem getting your report. Please try refreshing the page, and if that doesn't work, you can contact us at support@gyreteams.com";
  });

// @Component({
//   components: { CmsBody },
// })
// export default class AdHocGroupReport extends Vue {
//   @Prop() model!: CustomSoloReportApiModel;
//
//   doc: CmsCustomStrengthMapping | null = null;
//
//   isLoaded = false;
//
//   belowRequiredResponseCount = false;
//
//   error = "";
//
//   private label = "dynamic-render";
//
//   @Provide("report") report = this.model;
//
//   @ProvideReactive("values") values: string[] = [];
//
//   get titleHtml(): string {
//     return cms.asHtml(this.doc?.data?.report_title);
//   }
//
//   get subtitleHtml(): string {
//     return this.report.reportOwnerName;
//   }
//
//   get canShare(): boolean {
//     return !!this.model && csContext?.user?.id === this.model.reportOwnerId;
//   }
//
//   get sharingReportType(): ReportSharingTypeApiModel {
//     return "CustomFrameworkSoloReport";
//   }
//
//   get reportEntityId(): string {
//     return `${csContext.user.id}|${this.model.customStatistics?.id.toLowerCase()}`;
//   }
//
//   hideViewpointsSection(): CmsCustomStrengthMapping | null {
//     if (this.doc !== null && !this.model.customStatistics.viewpointsItems) {
//       this.doc.data.body = this.doc.data.body.filter((slice) => slice.slice_label !== this.label);
//     }
//     return this.doc;
//   }
//
//   async beforeMount() {
//     if (this.model == null) {
//       this.error =
//         "There was a problem getting your report. Please try refreshing the page, and if that doesn't work, you can contact us at support@gyreteams.com";
//       return;
//     }
//
//     if (!this.model.customStatistics?.soloItems) {
//       this.belowRequiredResponseCount = true;
//       return;
//     }
//
//     this.doc = await cms.getById(
//       CmsDocumentTypes.CmsCustomStrengthMapping,
//       this.model.userValues.metadata.id,
//     );
//
//     const reportList = this.doc.data?.body.find((slice) => slice.slice_type === "cms-report-list");
//     this.values = reportList?.items.map((value) => value.report_list_text[0].text) as string[];
//     this.doc = this.hideViewpointsSection();
//     this.isLoaded = true;
//   }
// }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(error.value), 1)
        ]))
      : _createCommentVNode("", true),
    (!error.value && isLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h1", null, _toDisplayString(props.name), 1)
                  ]),
                  _hoisted_9
                ])
              ])
            ]),
            (_unref(reportDoc))
              ? (_openBlock(), _createBlock(CmsTextPage, {
                  key: 0,
                  doc: _unref(reportDoc)
                }, null, 8, ["doc"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})